<template>
  <div
    class="bg-white dark:bg-dark-surface rounded-3xl border border-slate-100 dark:border-white/5 p-6 shadow-xl transition-colors"
  >
    <h3
      class="text-[10px] font-black uppercase tracking-widest text-primary mb-6 flex items-center gap-2"
    >
      <i class="fas fa-bolt text-amber-500"></i> {{ $t("quick_settings") }}
    </h3>
    <div class="space-y-3">
      <button
        @click="$emit('toggle-theme')"
        class="w-full flex justify-between items-center p-4 bg-slate-50 dark:bg-dark-input rounded-2xl border dark:border-white/5 hover:border-primary transition-all group"
      >
        <span class="text-xs font-bold">{{
          isDark ? $t("light_mode") : $t("dark_mode")
        }}</span>
        <span class="text-lg group-hover:scale-110 transition-transform">
          <i
            :class="
              isDark ? 'fas fa-sun text-amber-500' : 'fas fa-moon text-blue-500'
            "
          ></i>
        </span>
      </button>

      <button
        @click="$emit('change-locale', locale === 'en' ? 'ar' : 'en')"
        class="w-full flex justify-between items-center p-4 bg-slate-50 dark:bg-dark-input rounded-2xl border dark:border-white/5 hover:border-primary transition-all group"
      >
        <span class="text-xs font-bold">{{
          locale === "en" ? $t("arabic_language") : $t("english_language")
        }}</span>
        <div class="flex items-center gap-2">
          <i
            class="fas fa-globe text-slate-400 group-hover:text-primary transition-colors"
          ></i>
          <span
            class="text-xs font-black uppercase tracking-widest text-primary"
            >{{ locale === "en" ? "AR" : "EN" }}</span
          >
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardQuickSettings",
  props: {
    isDark: {
      type: Boolean,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
  },
};
</script>
